import React from "react";
import AboutSec3 from "../../../About/AboutSec3/AboutSec3";
import FinancialAuditSolution from "../../FinancialAuditSolution/FinancialAuditSolution";
import ServicesAuditApproach from "../../ServicesAuditApproach/ServicesAuditApproach";
import ServicesTrustedAcrossIndustries from "../../ServicesTrustedAcrossIndustries/TrustedAcrossIndustries";
import HomeAboutSec from "../../../Home/HomeAboutSec";
import HomeCtaBanner from "../../../Home/HomeCtaBanner/HomeCtaBanner";
import SEO from "../../../../components/SEO";
export default function FinanceAndAccounting({ currentLanguage = "en" }) {
  const pageTitles = {
    en: "Finance and Accounting",
    fr: "Finance et comptabilité",
  };
  const pageTitle = pageTitles[currentLanguage] || pageTitles.en;

  return (
    <div>
      <SEO title={pageTitle} />
      <AboutSec3 currentLanguage={currentLanguage} />
      <FinancialAuditSolution currentLanguage={currentLanguage} />
      <ServicesAuditApproach currentLanguage={currentLanguage} />
      <ServicesTrustedAcrossIndustries currentLanguage={currentLanguage} />
      <HomeAboutSec currentLanguage={currentLanguage} />
      <HomeCtaBanner currentLanguage={currentLanguage} />
    </div>
  );
}

